import { render, staticRenderFns } from "./FreeTag.vue?vue&type=template&id=755f6415&scoped=true"
import script from "./FreeTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreeTag.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FreeTag.vue?vue&type=style&index=0&id=755f6415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755f6415",
  null
  
)

export default component.exports